// extracted by mini-css-extract-plugin
export var brand = "_2z-9";
export var button = "_2z-0";
export var chevron = "_2z-v";
export var chevronButton = "_2z-w";
export var content = "_2z-n";
export var danger = "_2z-g";
export var dangerOutlined = "_2z-h";
export var dark = "_2z-l";
export var darkTheme = "_2z-c";
export var extraSmall = "_2z-4";
export var fullWidth = "_2z-8";
export var ghost = "_2z-d";
export var gray = "_2z-t";
export var icon = "_2z-p";
export var iconButton = "_2z-s";
export var iconButtonBorder = "_2z-x";
export var iconButtonBorderDark = "_2z-y";
export var iconButtonBorderLight = "_2z-z";
export var iconLeft = "_2z-q";
export var iconRight = "_2z-r";
export var large = "_2z-1";
export var light = "_2z-m";
export var medium = "_2z-2";
export var micro = "_2z-5";
export var nano = "_2z-7";
export var outlined = "_2z-k";
export var pending = "_2z-a";
export var primary = "_2z-i";
export var shadow = "_2z-o";
export var small = "_2z-3";
export var solidLight = "_2z-e";
export var solidLightBrand = "_2z-f";
export var spinner = "_2z-u";
export var transparent = "_2z-j";
export var warning = "_2z-b";
export var wideNano = "_2z-6";